import {
    useCreateOrUpdatePublishedWatchlist,
    usePublishedWatchlists,
} from 'utils/hooks';
import { Button } from '../Button';
import ModalContainer from 'components/Modal/ModalContainer';
import { PlaceholderText } from '../Placeholders';

const publishOptions = [
    {
        value: 'SUBSCRIBERS',
        label: 'subscribers: this watchlist will be visible to all Spate subscribers with the link',
    },
    {
        value: 'PRIVATE',
        label: 'private: this watchlist will be visible only to you',
    },
];

function PublishSettings({ watchlistId, isOpen, onClose }) {
    const { isLoading, isFetching, data } = usePublishedWatchlists();
    const { publish, isLoading: isMutating } =
        useCreateOrUpdatePublishedWatchlist();
    const publishedVersion =
        data && data.find(({ source_id }) => source_id === watchlistId);

    const visibility =
        publishedVersion &&
        publishedVersion.read_permission.includes('SUBSCRIBERS')
            ? 'SUBSCRIBERS'
            : isLoading
              ? null
              : 'PRIVATE';

    return (
        <ModalContainer isOpen={isOpen} onClose={onClose}>
            <h1 css="font-size: 16px; margin-bottom: 24px;">
                publish watchlist
            </h1>
            <div css="display: flex; flex-direction: column; text-align: left; gap: 24px;">
                <div>Change the visibility of this watchlist:</div>
                {publishOptions.map(({ value, label }) => (
                    <div css="vertical-align: baseline;" key={value}>
                        <input
                            type="radio"
                            id={value}
                            name="visibility"
                            value={value}
                            checked={visibility === value}
                            disabled={isLoading || isMutating}
                            onChange={(e) =>
                                publish({
                                    id: publishedVersion
                                        ? publishedVersion.id
                                        : null,
                                    watchlist: publishedVersion
                                        ? publishedVersion.source_id
                                        : watchlistId,
                                    read:
                                        e.target.value === 'PRIVATE'
                                            ? []
                                            : [e.target.value],
                                })
                            }
                        />
                        <label htmlFor={value}>{label}</label>
                    </div>
                ))}
                <div
                    css={`
                        opacity: ${visibility === 'PRIVATE' ? '.5' : '1'};
                        min-height: 3rem;
                    `}
                >
                    <div>Published Link</div>
                    <div css="font-size: .8rem;">
                        {publishedVersion && !publishedVersion.optimisticId ? (
                            `${location.origin}/watchlist/published/${publishedVersion.id}`
                        ) : ((!publishedVersion ||
                              publishedVersion.optimisticId) &&
                              (isMutating || isLoading)) ||
                          (visibility === 'SUBSCRIBERS' && isFetching) ? (
                            <div>
                                <PlaceholderText width="100%" />
                                <PlaceholderText width="60%" />
                            </div>
                        ) : (
                            `Publish this watchlist to obtain a link.`
                        )}
                    </div>
                </div>
                <Button
                    css="margin-left: auto;"
                    intent="secondary"
                    onClick={onClose}
                >
                    done
                </Button>
            </div>
        </ModalContainer>
    );
}

export default PublishSettings;
